import {IInteractionJson} from '../../../diagram-data/diagram-json-handler.service';

declare let mxConstants: any;
import {StyleKeeper} from './style-keeper.model';
import {ServerStyleObject, MxStyleObject} from '../styles.model';
import {FlowlineFormUtil} from '../../helpers/flowline-form.util';
import * as util from '../styles.util';
import {JUMP_STYLE, JUMP_STYLE_ARC} from '../../mx-graph/graph/mxLineJumps.extend';

export class FlowlineStyleKeeper implements StyleKeeper {
  constructor(
    private styles: ServerStyleObject,
    private flowlineObj: any
  ) {}

  public mxCellCssAsObject() {
    const result = <MxStyleObject>{};

    result.fontSize = parseInt(this.styles.fontSize, 10);
    result['shadow'] = this.styles.shadow ? 1 : 0;
    result['strokeWidth'] = this.styles.lineWidth;
    result['strokeColor'] = this.styles.lineColor;
    result['fontColor'] = this.styles.fontColor;
    result['fontStyle'] = util.calculateFontStyle(this.styles);
    result['fontFamily'] = this.styles.font;

    // hidden styles
    result['movable'] = 1;
    result['parent'] = 1;
    result['align'] = 'center';

    result['endArrow'] = 'classic';
    result['clonable'] = 0;
    result['curved'] = 0;
    result['html'] = 1;
    result['rounded'] = 1;

    result['edgeStyle'] = mxConstants.EDGESTYLE_ORTHOGONAL;
    result['jettySize'] = 'auto';
    result[JUMP_STYLE] = JUMP_STYLE_ARC;

    result['orthogonalLoop'] = 1;
    result['verticalAlign'] = 'middle';

    result[mxConstants.STYLE_SOURCE_JETTY_SIZE] = 30;
    result[mxConstants.STYLE_TARGET_JETTY_SIZE] = 30;

    return result;
  }

  public original() {
    return this.styles;
  }

  public fontCss() {
    return util.fontCss(this.styles);
  }

  public lineText() {
    const result = {};

    result['html'] = 1;
    result['align'] = 'center';
    result['verticalAlign'] = 'middle';
    result['resizable'] = 0;
    result['selectable'] = 0;
    result['rotatable'] = 0;

    result['fontColor'] = this.styles.fontColor;
    result['fontFamily'] = this.styles.font;
    result['fontSize'] = parseInt(this.styles.fontSize, 10);

    return util.objectToString(result, '=');
  }

  public interaction(data?: IInteractionJson) {
    const result = {};

    // result['html'] = 1;
    result['shape'] = 'ellipse';
    result['resizable'] = 0;
    result['selectable'] = 0;
    result['rotatable'] = 0;
    result['deletable'] = 0;
    result['editable'] = 0;
    result['align'] = 'center';
    result['verticalAlign'] = 'middle';
    result['fontColor'] = this.styles.fontColor;
    result['fontFamily'] = 'sans-serif';
    result['fontSize'] = 11;
    result['fontStyle'] = 1;
    result['strokeColor'] = data?.style?.lineColor || this.styles.lineColor;
    result['strokeWidth'] = 2;
    result['fillColor'] = data?.style?.backgroundColor || '#ffffff';

    return util.objectToString(result, '=');
  }

  public mxCellCss(opts?) {
    const result = this.mxCellCssAsObject();

    if (
      this.flowlineObj &&
      this.flowlineObj.position &&
      this.flowlineObj.position.connectionPoints
    ) {
      for (const key in this.flowlineObj.position.connectionPoints) {
        result[key] = this.flowlineObj.position.connectionPoints[key];
      }
    }

    if (this.flowlineObj) {
      const form = FlowlineFormUtil.newFormsItem(this.flowlineObj.flForm);
      const mxState = FlowlineFormUtil.get.mxState(form);

      Object.assign(result, mxState);
    }

    if (opts?.asObj) {
      return result;
    }

    return util.objectToString(result, '=');
  }
}
